module.exports = __webpack_public_path__ + "static/media/LH.0ab5f7a0.pdf";